import ProspectStore from './ProspectStore';

export * from './ProspectStore.dto';
export default new ProspectStore();
